/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Metadata_Merge_Match_By_LabelInputs */

const en_metadata_merge_match_by_label = /** @type {(inputs: Metadata_Merge_Match_By_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Match Events By`)
};

const fr_metadata_merge_match_by_label = /** @type {(inputs: Metadata_Merge_Match_By_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Événements de correspondance par`)
};

const de_metadata_merge_match_by_label = /** @type {(inputs: Metadata_Merge_Match_By_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spielereignisse von`)
};

const it_metadata_merge_match_by_label = /** @type {(inputs: Metadata_Merge_Match_By_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eventi di match`)
};

const ru_metadata_merge_match_by_label = /** @type {(inputs: Metadata_Merge_Match_By_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`События матча по`)
};

const es_metadata_merge_match_by_label = /** @type {(inputs: Metadata_Merge_Match_By_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eventos de partidos por`)
};

const zh_cn2_metadata_merge_match_by_label = /** @type {(inputs: Metadata_Merge_Match_By_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按比赛事件`)
};

const ja_metadata_merge_match_by_label = /** @type {(inputs: Metadata_Merge_Match_By_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`マッチイベント`)
};

const hi_metadata_merge_match_by_label = /** @type {(inputs: Metadata_Merge_Match_By_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मैच इवेंट्स द्वारा`)
};

const pt_pt2_metadata_merge_match_by_label = /** @type {(inputs: Metadata_Merge_Match_By_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eventos da partida por`)
};

/**
* | output |
* | --- |
* | "Match Events By" |
*
* @param {Metadata_Merge_Match_By_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const metadata_merge_match_by_label = /** @type {((inputs?: Metadata_Merge_Match_By_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Metadata_Merge_Match_By_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_metadata_merge_match_by_label(inputs)
	if (locale === "de") return de_metadata_merge_match_by_label(inputs)
	if (locale === "it") return it_metadata_merge_match_by_label(inputs)
	if (locale === "ru") return ru_metadata_merge_match_by_label(inputs)
	if (locale === "es") return es_metadata_merge_match_by_label(inputs)
	if (locale === "zh-CN") return zh_cn2_metadata_merge_match_by_label(inputs)
	if (locale === "ja") return ja_metadata_merge_match_by_label(inputs)
	if (locale === "hi") return hi_metadata_merge_match_by_label(inputs)
	if (locale === "pt-PT") return pt_pt2_metadata_merge_match_by_label(inputs)
	return en_metadata_merge_match_by_label(inputs)
});